
export class HourHelper {
    static combineHoursArrays(originalHours, addedHours) {
        if (originalHours == null || originalHours === undefined) {
            originalHours = {};
        }
        for (let i = 0; i < addedHours.length; i++) {
            const currentAddedHour = addedHours[i];
            //add date if not existing
            if (originalHours[currentAddedHour.date + ""] == null) {
                originalHours[currentAddedHour.date + ""] = {};
            }
            const date = originalHours[currentAddedHour.date + ""];
            //add hour if not existing
            if (date[currentAddedHour.hour + ""] == null) {
                date[currentAddedHour.hour + ""] = {};
            } else {
                // we copy the added hour, which results in a new reference and hence a re-render of that hour - se Hours
                date[currentAddedHour.hour + ""] = Object.assign({}, date[currentAddedHour.hour + ""])
            }
            const hour = date[currentAddedHour.hour + ""];
            //add entryNumber if not exiting
            if (hour[currentAddedHour.entryNumber + ""] == null) {
                hour[currentAddedHour.entryNumber + ""] = {};
            }

            const entry = hour[currentAddedHour.entryNumber + ""];
            entry.name = currentAddedHour.name;
            entry.contact = currentAddedHour.contact;
            entry.type = currentAddedHour.type;
            entry.entryNumber = currentAddedHour.entryNumber + "";
        }
        return originalHours;
    }
}

export default HourHelper;